import { render, staticRenderFns } from "./RoleFormModal.vue?vue&type=template&id=ec8026ee&scoped=true&"
import script from "./RoleFormModal.vue?vue&type=script&lang=js&"
export * from "./RoleFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8026ee",
  null
  
)

export default component.exports